import React, { useState } from 'react';
import { NO_IMAGE } from '@/_constant';

const ExclusivePropertyCard = ({ item, onClick, showPhone }) => {
  const [showPhoneNum, setShowPhoneNum] = useState(false);

  const name = item.name || item.title || "";
  const price = item.price ? (typeof item.price === 'number' ? `₹ ${item.price}` : item.price) : "";
  const builder = item.builder || item.createdBy || "Builder";
  const type = item.type || item.subtitle || "";
  const location = item.location || [item.district_name, item.state_name].filter(Boolean).join(", ") || "";
  const image = item.image || item.thumbnailUrl || NO_IMAGE;

  return (
    <div
      className="property-card bg-white rounded-4 shadow-sm overflow-hidden border-0"
      style={{ cursor: 'pointer', width: '100%', maxWidth: '380px' }}
      onClick={onClick}
    >
      <div className="property-img-container" style={{ height: '220px', overflow: 'hidden' }}>
        <img src={image} alt={name} className="img-fluid w-100 h-100" style={{ objectFit: 'cover' }} />
      </div>
      <div className="property-details p-3">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h5 className="property-name fw-bold mb-0 text-dark" style={{ fontSize: '1.1rem' }}>{name}</h5>
          <span className="property-price fw-bold" style={{ color: '#7E22CE', fontSize: '1rem' }}>{price}</span>
        </div>
        <p className="builder-name text-secondary small mb-3">By &lt;{builder}&gt;</p>

        <div className="border-top border-dotted pt-3">
          <p className="property-type fw-bold mb-3" style={{ fontSize: '0.9rem', color: '#333' }}>{type}</p>
          <div className="d-flex justify-content-between align-items-center" style={{ gap: '0.5rem' }}>
            <div className="location-info d-flex align-items-center text-secondary" style={{ fontSize: '0.85rem', minWidth: 0, flex: '1 1 auto' }}>
              <i className="bi bi-geo-alt-fill me-1" style={{ color: '#000', flexShrink: 0 }}></i>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{location}</span>
            </div>
            
            {showPhone ? (
              <div className="d-flex align-items-center gap-2">
                {showPhoneNum ? (
                  <span className="small text-secondary me-2" style={{ fontSize: '0.8rem' }}>
                    {!!item.assigneeUserId ? item.assigneeUserId : item?.createdBy}
                  </span>
                ) : null}
                <button 
                  className="btn view-details-btn rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '32px', height: '32px', padding: '0' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowPhoneNum(!showPhoneNum);
                  }}
                >
                  <i className="bi bi-telephone-fill" style={{ fontSize: '0.85rem' }}></i>
                </button>
                <button className="btn view-details-btn rounded-pill px-3 py-1 fw-bold" onClick={onClick}>
                  View Details
                </button>
              </div>
            ) : (
              <button className="btn view-details-btn rounded-pill px-3 py-1 fw-bold" onClick={onClick}>
                View Details
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExclusivePropertyCard;
